import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";

import { RestoreComponent } from "./restore.component";

@NgModule({
    declarations: [
    RestoreComponent
    ],
    imports: [
      FormsModule,
      CommonModule
    ],
    providers: [
    ]
})
export class RestoreModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/restore/restore.module.ts